import type { AxiosInstance } from 'axios';
import axios from 'axios';
import * as AxiosLogger from 'axios-logger';

import { getEnv } from '@apple/utils/config/env';
import { sleep } from '@apple/utils/sleep';
import { parseServerError } from '@apple/utils/validation/server';

export function configAxios() {
	const { APPLE_API_URL, APPLE_DEV_API_REQUEST_DELAY_MS, DEV } = getEnv();
	axios.defaults.baseURL = APPLE_API_URL;
	// https://github.com/axios/axios/issues/1322
	// https://github.com/aspnet/AspNetKatana/blob/43996b47015ca0c0ad12cdb6c87a017534eec620/src/Microsoft.Owin.Security.Cookies/Provider/DefaultBehavior.cs#L50
	axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
	// Forces sending cookies along with requests that are for a different domain than the site
	axios.defaults.withCredentials = true;
	axios.defaults.withXSRFToken = true;
	// ASP.NET Core does not bind axios's default `ids[]=1` array form; it needs `ids[0]=1`
	axios.defaults.paramsSerializer = { indexes: true };
	// axiosBetterStacktrace(axios);

	if (DEV) {
		AxiosLogger.setGlobalConfig({
			// data: true,
			method: true,
			url: true,
			status: true,
			// headers: true,
			// params: true,
		});

		axios.interceptors.request.use(AxiosLogger.requestLogger, AxiosLogger.errorLogger);
		// axios.interceptors.response.use(AxiosLogger.responseLogger, AxiosLogger.errorLogger);
	}

	setupServerValidationHandler(axios);

	if (APPLE_DEV_API_REQUEST_DELAY_MS !== undefined) {
		setupArtificialDelayHandler(axios, APPLE_DEV_API_REQUEST_DELAY_MS);
	}
}

export function setupServerValidationHandler(instance: AxiosInstance): void {
	instance.interceptors.response.use(
		success => success,
		(error: unknown) => {
			if (axios.isCancel(error)) {
				return Promise.reject(error);
			}

			throw parseServerError(error);
		},
	);
}

export function setupArtificialDelayHandler(instance: AxiosInstance, delayMs: number): void {
	instance.interceptors.response.use(
		async success => {
			await sleep(delayMs);
			return success;
		},
		async (error: unknown) => {
			await sleep(delayMs);
			throw error;
		},
	);
}
